import AppDialogHeader from "components/ui/AppDiaglogHeader";
import { AppChip } from "components/ui/Chips/AppChip";
import { observer } from "mobx-react-lite";
import { ITrackingDiagnostic } from "types/models/TrackingDiagnosticsModel";
import { getTrackingDiagnosticsSessionTypeColor, getTrackingDiagnosticsTypeColor } from "utilities/SystemUtils";

interface ITrackingDiagnosticsAppDialogHeaderProps {
    title?: string;
    stickyHeader?: boolean;
    trackingDiagnostic: ITrackingDiagnostic | null
}

export const TrackingDiagnosticsAppDialogHeader = observer(({ title, stickyHeader, trackingDiagnostic }: ITrackingDiagnosticsAppDialogHeaderProps) => (
    <AppDialogHeader title={title} stickyHeader={stickyHeader}>
        <div className="d-flex justify-content-between align-items-center px-3 py-2">
            <div className='d-flex' style={{ minWidth: '120px' }}>
                {
                    <AppChip<string> value={trackingDiagnostic?.sessionType ?? null} getColor={() => getTrackingDiagnosticsSessionTypeColor(trackingDiagnostic?.sessionType ?? null)} />
                }
            </div>

            <h3 className="font-22 font-500 text-uppercase mb-0 text-center flex-grow-1">
                {title}
            </h3>

            <div className="d-flex gap-10px">
                {
                    <AppChip<string> value={trackingDiagnostic?.type ?? null} getColor={() => getTrackingDiagnosticsTypeColor(trackingDiagnostic?.type ?? null)} />
                }
            </div>
        </div>
    </AppDialogHeader>
));

export default TrackingDiagnosticsAppDialogHeader;